import { render, staticRenderFns } from "./NewCertificate.vue?vue&type=template&id=055261fd&scoped=true"
import script from "./NewCertificate.vue?vue&type=script&lang=js"
export * from "./NewCertificate.vue?vue&type=script&lang=js"
import style0 from "./NewCertificate.vue?vue&type=style&index=0&id=055261fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055261fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VColorPicker,VCombobox,VForm,VTextField})
